import React, { useState, useRef, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { NavLink, useNavigate } from "react-router-dom";
import { LoginUser, reset } from "../features/authSlice.js";
import Header from "./Header.jsx";
import axios from "axios";
import Cookies from "js-cookie";
import {
  API_URL2,
  API_URL_LOGIN,
  API_URL_PHOTO,
  API_URL_SAVE_ANSWER,
  SECRET_SESSION,
} from "../constants";
import { SignUpUser } from "../features/signUpSlice.js";
import parseHtml from "html-react-parser";
import { encrypt, decrypt_res } from "./shares/GlobalFunction.jsx";
import { UserIcon, KeyIcon, EyeIcon, EyeOffIcon } from "@heroicons/react/solid";
import Webcam from "react-webcam";
import Loader from "./shares/Loader.jsx";
import axiosInstance from "./shares/axiosConfig.js";
import moment from "moment-timezone";

// import Camera from "./shares/Camera.js";

const baseURL = API_URL2 + "/login/info";
const baseURL2 = API_URL2 + "/login/tokensignup";
const baseURL3 = API_URL2 + "/login/signup2";

//create function logout and redirect to login
export const LoadTest = () => {
  axios.post(baseURL).then((response) => {
    // alert(JSON.stringify(response.data.res));
  });

  //registrasi peserta
  //1. get token
  const token = "88998899";
  axios.post(baseURL2).then((response) => {
    // alert(response.data.res.token);
  });

  //2. registrasi peserta
  let userData = null;
  axios
    .post(baseURL3, {
      nama_lengkap: "Nama Lengkap",
      asal_instansi: "Asal Instansi",
      grup_peserta: "Grup Peserta",
      jenis_kelamin: "L",
      token: token,
    })
    .then((response1) => {
      userData = response1;
      //alert(JSON.stringify(userData.data.peserta));

      //login
      axios
        .post(API_URL2 + "/login/proses", {
          username: userData.data.peserta.nopes,
          password: userData.data.peserta.kode_akses,
          token: token,
        })
        .then((response2) => {
          //mulai tes
          //get subtes

          axiosInstance
            .post(API_URL2 + "/peserta/subtest", {
              id_projek: userData.data.peserta.id_projek,
              id_siswa: userData.data.peserta.id_siswa,
              id_ujian: userData.data.peserta.id_ujian || 0,
              username: userData.data.peserta.nopes,
              kode_akses: userData.data.peserta.kode_akses,
            })
            .then((response3) => {
              // alert(JSON.stringify(response3.data.data[0]));
              //get soal
              axiosInstance
                .post(API_URL2 + "/peserta/mulaites", {
                  id_projek: userData.data.peserta.id_projek,
                  id_siswa: userData.data.peserta.id_siswa,
                  id_projek_ujian: response3.data.data[0].id_projek_ujian,
                  id_paket_soal: response3.data.data[0].id_paket_soal,
                })
                .then((response4) => {
                  //get soal
                  axiosInstance
                    .post(API_URL2 + "/peserta/daftarsoal", {
                      id_projek: userData.data.peserta.id_projek,
                      id_siswa: userData.data.peserta.id_siswa,
                      id_projek_ujian: response3.data.data[0].id_projek_ujian,
                      id_naskah: response3.data.data[0].id_naskah,
                      kode_paket_soal: response3.data.data[0].id_paket_soal,
                      id_ujian: response4.data.data[0].id_ujian,
                    })
                    .then((response5) => {
                      let newStatusJawaban = [];
                      let newIdSoal = [];
                      let newWaktuMengerjakan = [];
                      let newStatusSave = [];
                      let newJenisSoal = [];
                      response5.data.data.listSoal.map((item) => {
                        newJenisSoal[item.no_soal - 1] = parseInt(
                          item.jenis_soal
                        );
                        newIdSoal[item.no_soal - 1] = item.id_soal;
                        newStatusJawaban[item.no_soal - 1] = "A";
                        newWaktuMengerjakan[item.no_soal - 1] = moment().format(
                          "YYYY-MM-DD HH:mm:ss"
                        );
                        newStatusSave[item.no_soal - 1] = 0;

                        return item;
                      });

                      //save jawaban
                      //finish test
                      axiosInstance
                        .post(API_URL2 + "/peserta/autosave_jawaban", {
                          id_projek: userData.data.peserta.id_projek,
                          id_siswa: userData.data.peserta.id_siswa,
                          id_ujian: response4.data.data[0].id_ujian,
                          soal: newIdSoal.join(","),
                          statusJawaban: newStatusJawaban.join(","),
                          waktuMengerjakan: newWaktuMengerjakan.join(","),
                          statusSave: newStatusSave.join(","),
                          jenisSoal: newJenisSoal.join(","),
                        })
                        .then((response6) => {
                          axiosInstance
                            .post(API_URL2 + "/peserta/selesaites2", {
                              id_projek: userData.data.peserta.id_projek,
                              id_siswa: userData.data.peserta.id_siswa,
                              id_projek_ujian:
                                response3.data.data[0].id_projek_ujian,
                              id_ujian: response4.data.data[0].id_ujian,
                              id_naskah: response3.data.data[0].id_naskah,
                              jawaban: "",
                            })
                            .then((response7) => {
                              axiosInstance
                                .post(API_URL2 + "/peserta/subtest", {
                                  id_projek: userData.data.peserta.id_projek,
                                  id_siswa: userData.data.peserta.id_siswa,
                                  id_ujian: userData.data.peserta.id_ujian || 0,
                                  username: userData.data.peserta.nopes,
                                  kode_akses: userData.data.peserta.kode_akses,
                                })
                                .then((response3) => {
                                  // alert(JSON.stringify(response3.data.data[0]));
                                  //get soal
                                  axiosInstance
                                    .post(API_URL2 + "/peserta/mulaites", {
                                      id_projek:
                                        userData.data.peserta.id_projek,
                                      id_siswa: userData.data.peserta.id_siswa,
                                      id_projek_ujian:
                                        response3.data.data[0].id_projek_ujian,
                                      id_paket_soal:
                                        response3.data.data[0].id_paket_soal,
                                    })
                                    .then((response4) => {
                                      //get soal
                                      axiosInstance
                                        .post(
                                          API_URL2 + "/peserta/daftarsoal",
                                          {
                                            id_projek:
                                              userData.data.peserta.id_projek,
                                            id_siswa:
                                              userData.data.peserta.id_siswa,
                                            id_projek_ujian:
                                              response3.data.data[0]
                                                .id_projek_ujian,
                                            id_naskah:
                                              response3.data.data[0].id_naskah,
                                            kode_paket_soal:
                                              response3.data.data[0]
                                                .id_paket_soal,
                                            id_ujian:
                                              response4.data.data[0].id_ujian,
                                          }
                                        )
                                        .then((response5) => {
                                          let newStatusJawaban = [];
                                          let newIdSoal = [];
                                          let newWaktuMengerjakan = [];
                                          let newStatusSave = [];
                                          let newJenisSoal = [];
                                          response5.data.data.listSoal.map(
                                            (item) => {
                                              newJenisSoal[item.no_soal - 1] =
                                                parseInt(item.jenis_soal);
                                              newIdSoal[item.no_soal - 1] =
                                                item.id_soal;
                                              newStatusJawaban[
                                                item.no_soal - 1
                                              ] = "A";
                                              newWaktuMengerjakan[
                                                item.no_soal - 1
                                              ] = moment().format(
                                                "YYYY-MM-DD HH:mm:ss"
                                              );
                                              newStatusSave[
                                                item.no_soal - 1
                                              ] = 0;

                                              return item;
                                            }
                                          );

                                          //save jawaban
                                          //finish test
                                          axiosInstance
                                            .post(
                                              API_URL2 +
                                                "/peserta/autosave_jawaban",
                                              {
                                                id_projek:
                                                  userData.data.peserta
                                                    .id_projek,
                                                id_siswa:
                                                  userData.data.peserta
                                                    .id_siswa,
                                                id_ujian:
                                                  response4.data.data[0]
                                                    .id_ujian,
                                                soal: newIdSoal.join(","),
                                                statusJawaban:
                                                  newStatusJawaban.join(","),
                                                waktuMengerjakan:
                                                  newWaktuMengerjakan.join(","),
                                                statusSave:
                                                  newStatusSave.join(","),
                                                jenisSoal:
                                                  newJenisSoal.join(","),
                                              }
                                            )
                                            .then((response6) => {
                                              axiosInstance
                                                .post(
                                                  API_URL2 +
                                                    "/peserta/selesaites2",
                                                  {
                                                    id_projek:
                                                      userData.data.peserta
                                                        .id_projek,
                                                    id_siswa:
                                                      userData.data.peserta
                                                        .id_siswa,
                                                    id_projek_ujian:
                                                      response3.data.data[0]
                                                        .id_projek_ujian,
                                                    id_ujian:
                                                      response4.data.data[0]
                                                        .id_ujian,
                                                    id_naskah:
                                                      response3.data.data[0]
                                                        .id_naskah,
                                                    jawaban: "",
                                                  }
                                                )
                                                .then((response7) => {
                                                  //finish
                                                  axiosInstance
                                                    .post(
                                                      API_URL2 +
                                                        "/peserta/info_hasil",
                                                      {
                                                        id_projek:
                                                          userData.data.peserta
                                                            .id_projek,
                                                        id_siswa:
                                                          userData.data.peserta
                                                            .id_siswa,
                                                      }
                                                    )
                                                    .then((response8) => {
                                                      // alert(JSON.stringify(response.data.data));
                                                    });
                                                });
                                            });
                                        });
                                    });
                                });
                              //   //finish
                              //   axiosInstance
                              //     .post(API_URL2 + "/peserta/info_hasil", {
                              //       id_projek: userData.data.peserta.id_projek,
                              //       id_siswa: userData.data.peserta.id_siswa,
                              //     })
                              //     .then((response8) => {
                              //       // alert(JSON.stringify(response.data.data));
                              //     });
                            });
                        });
                    });
                });
            });
          //alert(JSON.stringify(response));
        });
    });

  // React.useEffect(() => {
  //   if (effectsCompleted >= 1) {
  //     setIsLoadingPage(false);
  //   }
  // }, [effectsCompleted]);
};
